import styled from "styled-components";

import { BREAKPOINTS } from "context/media/MediaConstant";

// eslint-disable-next-line import/prefer-default-export
export const CaptchaContainer = styled.div`
  height: 40px;
  width: 100px;
  display: flex;

  justify-content: flex-start;
  align-items: "center";
  flex-direction: "row";
  flex-wrap: "wrap";

  @media (max-width: ${BREAKPOINTS.MOBILE}px) {
    width: 30%;
  }
`;
